class FormFollowup {
    constructor() {
        /*this.formId = 2;
        this.followUpText = '<span class="gform_followup-text">A Customer Service Team Member will follow up! </span>';*/
    }

    _injectFollowUp = () => {
        /*const legend = document.querySelector(`#gform_wrapper_${this.formId} .gform_required_legend`);

        if (legend && !legend.querySelector('.gform_followup-text')) {
            legend.insertAdjacentHTML('afterbegin', this.followUpText);
            return true;
        }*/
        return false;
    }

    _startPolling = () => {
        /*const maxAttempts = 20; 
        let attempts = 0;
        
        const intervalId = setInterval(() => {
            if (this._injectFollowUp() || attempts >= maxAttempts) {
                clearInterval(intervalId);
            }
            attempts++;
        }, 200); */
    }

    init() {
        /*if (typeof jQuery !== 'undefined') {
            jQuery(function($) {
                $(document).on('gform_post_render', (event, formId) => {
                    if (formId === this.formId) {
                        this._injectFollowUp();
                    }
                });
            }.bind(this)); 
        }

        this._injectFollowUp();
        
        this._startPolling();*/
    }
}

export default FormFollowup;
